<script>
  console.log("Menu: Svelte menu is running");
  import { onMount, onDestroy } from "svelte";
  import Mods from "./Mods.svelte";
  import Credits from "./Credits.svelte";
  import Load from "./Load.svelte";
  import Help from "./Help.svelte";
  import Encyclopedia from "./Encyclopedia.svelte";
  import Legal from "./Legal.svelte";
  import Options from "./Options.svelte";
  import Pie from "./Pie.svelte";
  import Localization from "./Localization.svelte";
  import PageInProgress from "./PageInProgress.svelte";
  import {
    PLAY,
    OPTIONS,
    CREDITS,
    MODS,
    HELP,
    TODO,
    LOCALIZATION,
    MULTIPLAYER_SERVER_CHOOSER,
    LOAD_GAMES,
    LEGAL,
    ENCYCLOPEIDA,
  } from "./routes";
  import Multiplayer from "./Multiplayer.svelte";
  import MageTypeChooser from "./MageTypeChooser.svelte";
  import PrivacyPolicyPopup from "./PrivacyPolicyPopup.svelte";
  let route;
  let inGame = false;
  let forceRerender = 0;
  // Used when changing the language to ensure the menu
  // updates to the new language
  window.refreshMenu = () => {
    console.log("Force refresh menu");
    forceRerender += 1;
  };
  window.updateInGameMenuStatus = () => {
    inGame = window.player !== undefined;
  };
  setRoute(PLAY);
  function setRoute(r) {
    console.log("Menu: Route:", r);
    document.body.classList.toggle(`route-${route}`, false);
    route = r;
    window.updateInGameMenuStatus();
    document.body.classList.toggle(`route-${route}`, true);
  }
  window.goBack = function goBack() {
    setRoute(PLAY);
  };
  function keydownListener(event) {
    switch (event.code) {
      case "Escape":
        goBack();
        break;
    }
  }

  let updateProgress = 0;
  // Start with updateComplete set to true so that the update UI will
  // ONLY EVER hide the play ui if update messages start coming through
  let updateComplete = true;
  onMount(() => {
    document.body.addEventListener("keydown", keydownListener);
  });

  onDestroy(() => {
    document.body.removeEventListener("keydown", keydownListener);
  });
  window.setMenu = setRoute;
  window.getMenuRoute = () => route;
</script>

<PrivacyPolicyPopup />
{#key forceRerender}
  <div id="menu">
    <div class="full-fill">
      <div class="decorative-border">
        {#if route == PLAY}
          <div id="main-menu">
            <div id="main-menu-inner">
              <img
                id="logo"
                src="ui/logo.png"
                alt="Spellmasons logo"
                width="800"
              />
              {#if updateComplete}
                <Pie {setRoute} {inGame} />
              {:else}
                <span>Update progress:</span>
                <div class="progress">
                  <div
                    style={`width:${Math.max(
                      // Always give enough room to show the percentage text
                      15,
                      Math.floor(updateProgress * 100),
                    )}%`}
                  >
                    {Math.floor(updateProgress * 100)}% &nbsp;
                  </div>
                </div>
              {/if}
            </div>
          </div>
        {:else if route == MULTIPLAYER_SERVER_CHOOSER}
          <Multiplayer route {setRoute} />
        {:else if route == LOCALIZATION}
          <Localization route />
        {:else if route == LOAD_GAMES}
          <Load route {setRoute} />
        {:else if route == OPTIONS}
          <Options route {setRoute} />
          <!-- {:else if route == MAGE_TYPE}
          <MageTypeChooser route {setRoute} /> -->
        {:else if route == CREDITS}
          <Credits route />
        {:else if route == MODS}
          <Mods route />
        {:else if route == LEGAL}
          <Legal route />
        {:else if route == HELP}
          <Help route />
        {:else if route == ENCYCLOPEIDA}
          <Encyclopedia route {setRoute} />
        {:else if route == TODO}
          <PageInProgress route />
        {/if}
      </div>
    </div>
  </div>
{/key}

<style global lang="scss">
  /* Accessibility override */
  body.font-arial * {
    font-family: Arial, Helvetica, sans-serif !important;
  }
  .pointer-events--all {
    pointer-events: all;
  }
  a:visited {
    color: pink;
  }
  body {
    margin: 0;
  }
  .max-width-800 {
    max-width: 800px;
  }
  #logo {
    width: 100%;
    margin: 0 auto;
    max-width: 800px;
  }
  #menu {
    color: white;
    font-family: Forum;
  }
  .aside-title {
    display: inline-block;
    margin: 0;
  }
  main {
    // Match the aside
    padding-top: 20px;
  }
  #main-menu {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  #main-menu-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .progress {
    height: 32px;
    width: 250px;
    appearance: none;
    border-radius: 8px;
    margin: 8px;
    border: 1px solid #320573;
  }
  .progress > div {
    background-image: -webkit-linear-gradient(left, #320573, #9717e3);
    border-radius: 8px;
    text-align: right;
    line-height: 32px;
    height: 32px;
  }
  #main-menu input {
    font-size: inherit;
    -webkit-padding: 0.4em 0;
    padding: 0.4em;
    margin: 0 0 0.5em 0;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 2px;
    width: 100%;
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 250px;
    font-family: Forum;
  }
  // ------------------------
  .height100 {
    height: 100%;
  }
  .overflowyscroll {
    overflow-y: scroll;
  }
  .flex {
    display: flex;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .flex-direction-column {
    flex-direction: column;
  }

  .justify-content-space-between {
    justify-content: space-between;
  }
  .align-items-center {
    align-items: center;
  }
  .gap-20 {
    gap: 20px;
  }
  .gap-15 {
    gap: 15px;
  }
  .margin-bottom-15 {
    margin-bottom: 15px;
  }
  $button-purple: #483f8e;
  // Remove default button styling
  .button-wrapper {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    color: white;
    text-align: center;
    width: 100%;
    text-transform: capitalize;
  }
  .button-wrapper.sm {
    max-width: 120px;
  }
  .button-wrapper {
    border: 16px solid;
    border-image-outset: 0;
    border-image-repeat: stretch;
    border-image-slice: 250;
    border-image-source: url("/ui/Assets_Icon_Border_QtrCircle_2_Purple.png");
    border-image-width: 1;
    transition: 0.1s;
    // Allow button to scale without blurring. Credit: https://stackoverflow.com/a/16878602/4418836
    backface-visibility: hidden;
    transform: translateZ(0);
    -webkit-font-smoothing: subpixel-antialiased;
    /* background-clip ensures that the background color wont overlap the border */
    background-clip: padding-box;
    background-color: $button-purple;
  }
  .button-wrapper:disabled,
  .button-wrapper.appear-disabled {
    border-image-source: url("/ui/Assets_Icon_Border_QtrCircle_3.png");
    background-color: #262324;
  }
  .button-wrapper:disabled .icon {
    // Tint disabled button icons grey
    filter: brightness(50%);
  }
  .button-wrapper.button-wrapper-bg-2 {
    border-image-source: url("/ui/Assets_Icon_Border_QtrCircle_1_Purple.png");
  }

  .button-wrapper:hover {
    filter: brightness(125%) drop-shadow(2px 2px 0px #8f84e9);
  }

  .button-wrapper.is-active {
    filter: brightness(145%) drop-shadow(4px 4px 0px #8f84e9);
  }

  .button-wrapper div {
    padding: 0 10px;
  }

  button:disabled {
    color: #999;
  }

  button:focus {
    border-color: #666;
  }
  .list {
    gap: 10px;
    display: flex;
    flex-direction: column;
  }
  .full-fill {
    width: 100vw;
    height: 100vh;
  }
  .decorative-border {
    width: 100%;
    height: 100%;
    border: 20px solid;
    user-select: none;
    border-image-source: url("/ui/Assets_Gif_Border.png");
    border-image-slice: 30;
    border-image-width: 50px;
    border-image-outset: 0;
    box-sizing: border-box;
    // background-color is necessary for this border on FF but it must not be set on Chrome
    // background-color: #171717;
    overflow-y: auto;
  }
  .pad-20 {
    padding: 20px;
  }

  .error-inline {
    color: red;
    margin: 8px 0;
  }
</style>
